<template>
  <v-container>
    <v-row class="pt-5">
      <v-col sm="12" md="6" lg="6">
        <div class="h1">How can we help?</div>
        <div class="p pt-5">
          <b> Do you have a question?</b>

          <br />
          <br />
          Tell us what’s on your mind!
          <br />
          <br />
          <v-icon color="blue darken-4" size="30" class="px-1 pt-5">
            mdi-facebook
          </v-icon>
          <v-icon color="blue lighten-1" size="30" class="px-1 pt-5">
            mdi-linkedin
          </v-icon>
          <v-icon color="red accent-4" size="30" class="px-1 pt-5">
            mdi-instagram</v-icon
          >
          <v-icon color="light-blue" size="30" class="px-1 pt-5">
            mdi-twitter</v-icon
          >
          <v-icon color="green" size="30" class="px-1 pt-5">
            mdi-whatsapp</v-icon
          >
          <br />
          <br />
          <div class="head pt-5"><b>Address</b></div>
          <p class="pt-2">
            Kenwyn Consultancy Services PVT. Ltd <br />No 20, 2nd Lane
            Linganagar,<br />
            Trincomalee
          </p>
          <div class="head pt-5"><b>Contact</b></div>
          <p class="pt-5">+94-26 205 5830</p>
          <div class="head pt-5"><b>Email Address</b></div>
          <p class="pt-5">info@myeduvisa.com</p>
        </div>
        <br />
      </v-col>
      <v-col sm="12" md="6" lg="6">
        <v-sheet class="pa-5 card" color="grey lighten-3">
          <div class="sheetDiv">
            <div class="pt-2 pl-2 pb-2 h2">Get In Touch</div>
          </div>
          <div class="pt-1 pl-2 pb-1 divColor"></div>
          <v-row class="pt-4">
            <v-col sm="12" md="6" lg="6">
              <v-text-field
                label="Name"
                placeholder="Name"
                color="black"
                filled
                rounded
                dense
              ></v-text-field
            ></v-col>
            <v-col sm="12" md="6" lg="6">
              <v-text-field
                label="Email"
                color="black"
                placeholder="Email"
                filled
                rounded
                dense
              ></v-text-field
            ></v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="6" lg="6">
              <v-text-field
                label="Phone"
                color="black"
                placeholder="Name"
                filled
                rounded
                dense
              ></v-text-field
            ></v-col>
            <v-col sm="12" md="6" lg="6">
              <v-select
                :items="branch"
                filled
                label="Select Branch"
                color="black"
                placeholder="Branch"
                rounded
                dense
              ></v-select
            ></v-col>
          </v-row>

          <v-row>
            <v-col sm="12" md="6" lg="6">
              <v-select
                :items="country"
                label="Interested Country"
                color="black"
                placeholder=" Country"
                filled
                rounded
                dense
              ></v-select>
            </v-col>
            <v-col sm="12" md="6" lg="6">
              <v-select
                :items="study"
                label="Service Interested"
                color="black"
                placeholder="Service "
                filled
                rounded
                dense
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" lg="12">
              <v-textarea
                filled
                auto-grow
                label="Message"
                color="black"
                rows="4"
                row-height="20"
                shaped
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12" md="12" lg="12">
              <v-checkbox>
                <template v-slot:label>
                  <div>
                    Yes, I want to opt-in for regular Immigration updates.
                  </div>
                </template>
              </v-checkbox>
            </v-col></v-row
          >
          <div class="text-left">
            <v-btn rounded color="green accent-4" dark><b> Submit </b></v-btn>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      branch: [],
      country: ["Singapore", "Malaysia", "UK"],
      study: ["PR visa", "Study Visa", "Visit Visa", "Others"],
    };
  },
};
</script>
<style scoped>
.h1 {
  text-align: center;
  font-size: 30px;
}
.p {
  text-align: center;
  font-size: 15px;
}
.h2 {
  font-size: 30px;
}
.card {
  border-radius: 10px;
}
.sheetDiv {
  background-color: rgb(227, 227, 227);
}
.divColor {
  background-color: rgb(150, 150, 150);
}
.head {
  font-size: 20px;
}
</style>